import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSettlementPaidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 7,
	viewBox: "0 0 17 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.0088 2.8C12.4717 1.55556 10.4775 0.777778 8.27566 0.777778C4.41202 0.777778 1.14663 3.13444 0 6.39333L1.9609 7C2.39829 5.75542 3.24423 4.67185 4.37812 3.90372C5.51201 3.13559 6.876 2.72211 8.27566 2.72222C9.8959 2.72222 11.3749 3.28222 12.5298 4.18444L9.52199 7H17V0L14.0088 2.8Z",
		fill: "#D74949"
	})
});
export default SvgSettlementPaidIcon;
